import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    homeInfo: null,
    newsDetail: null
  },
  mutations: {
    M_Home_Info(state, data) {
      state.homeInfo = data;
      console.log('M_Home_Info ---- state.homeInfo ', state.homeInfo)
    }
  },
  actions: {
    
  },
  getters: {},
  modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js